import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

import { ChatState, createChatSlice } from './slices/chat.slice';
import { CommentState, createCommentSlice } from './slices/comment.slice';
import {
  UnreadCommunicationState,
  createUnreadCommunicationSlice,
} from './slices/communication.slice';
import {
  CustomerTypeState,
  createCustomerTypeSlice,
} from './slices/customer-type.slice';
import {
  DelegationState,
  createDelegationSlice,
} from './slices/delegation.slice';
import {
  DocumentToQualifyState,
  createDocumentToQualifySlice,
} from './slices/document-to-qualify.slice';
import {
  InactivityState,
  createInactivitySlice,
} from './slices/inactivity.slice';
import { LoadingState, createLoadingSlice } from './slices/is-loading.slice';
import { ManagerState, createManagerSlice } from './slices/manager.slice';
import { MinWageState, createMinWageSlice } from './slices/min-wage.slice';
import { ModalState, createModalSlice } from './slices/modal.slice';
import {
  NewCommentState,
  createNewCommentSlice,
} from './slices/new-comment.slice';
import {
  NotificationState,
  createNotificationSlice,
} from './slices/notification.slice';
import { PecRateState, createPecRateSlice } from './slices/pec-rate.slice';
import {
  RefundRequestState,
  createRefundRequestSlice,
} from './slices/refund-request.slice';
import {
  TemporaryDocumentState,
  createTemporaryDocumentSlice,
} from './slices/temporary-document.slice';
import { ToastState, createToastSlice } from './slices/toast.slice';
import {
  TrainingActionDeviceMapState,
  createTrainingActionDeviceMapSlice,
} from './slices/training-action-device-map.slice';
import {
  TrainingActionState,
  createTrainingActionSlice,
} from './slices/training-action.slice';
import {
  TrainingCourseState,
  createTrainingCourseSlice,
} from './slices/training-course.slice';
import { UserState, createUserSlice } from './slices/user.slice';

const useStore = create<
  ChatState &
    CommentState &
    UnreadCommunicationState &
    LoadingState &
    DocumentToQualifyState &
    ManagerState &
    MinWageState &
    ToastState &
    ModalState &
    NewCommentState &
    UserState &
    NotificationState &
    TemporaryDocumentState &
    TrainingActionDeviceMapState &
    TrainingCourseState &
    TrainingActionState &
    RefundRequestState &
    PecRateState &
    DelegationState &
    InactivityState &
    CustomerTypeState
>()(
  devtools(
    (...a) => ({
      ...createChatSlice(...a),
      ...createCommentSlice(...a),
      ...createUnreadCommunicationSlice(...a),
      ...createLoadingSlice(...a),
      ...createDocumentToQualifySlice(...a),
      ...createManagerSlice(...a),
      ...createMinWageSlice(...a),
      ...createToastSlice(...a),
      ...createModalSlice(...a),
      ...createNewCommentSlice(...a),
      ...createUserSlice(...a),
      ...createNotificationSlice(...a),
      ...createTemporaryDocumentSlice(...a),
      ...createTrainingActionDeviceMapSlice(...a),
      ...createTrainingCourseSlice(...a),
      ...createTrainingActionSlice(...a),
      ...createRefundRequestSlice(...a),
      ...createPecRateSlice(...a),
      ...createDelegationSlice(...a),
      ...createInactivitySlice(...a),
      ...createCustomerTypeSlice(...a),
    }),
    {
      name: 'ALEC - ERP FORMATION (ZUSTAND)',
    },
  ),
);
export default useStore;
